import Quill from 'quill';

let icons = Quill.import('ui/icons');

// Sparkle: the AI writing tool.
icons['text-generation'] = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10 2l1.9 5.1L17 9l-5.1 1.9L10 16l-1.9-5.1L3 9l5.1-1.9L10 2zm8 10l1 2.6 2.6 1-2.6 1L18 19.2l-1-2.6-2.6-1 2.6-1L18 12zM6 16l.7 1.8 1.8.7-1.8.7L6 21l-.7-1.8-1.8-.7 1.8-.7L6 16z"/></svg>';
